import React from 'react';
import './Bonus.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function Bonus({ content }) {

    return (
        <div className='workshop-bonus'>
            {
                content.Titre &&
                    content.Titre === "+" ?
                        <span className='plus'>{content.Titre}</span>
                    :
                        <span className='workshop-bonus__titre'>{content.Titre}</span>
            }
            <ul className='workshop-bonus__bonus_list'>
                {
                    content.Modules.map((module) => (
                        <li
                            key={module.id}
                            className='workshop-bonus__bonus_item'
                            style={{
                                backgroundColor: module.CouleurArrièrePlan,
                                color: module.CouleurTexte
                            }}
                        >
                            <StrapiImageWithSkeleton
                                picture={module.Photo}
                                loading="lazy"
                                size='thumbnail'
                            />
                            <h3>{module.Titre}</h3>
                            <p className='workshop-bonus__bonus_subtitle'>
                                {module.SousTitre}
                            </p>
                            <div className="workshop-bonus__bonus_content" dangerouslySetInnerHTML={safeHtml(module.Texte)} />
                        </li>

                    ))
                }
            </ul>
        </div>
    )
}